<template>
  <div style="height: 100%; flex-direction: row;">
    <div style="min-width: 1050px; height: 100%">
      <div class="section operations">
        <div v-show="cooperateEdit" class="triggers">
          <div v-show="showButton" style="width: 100%">
            <el-button v-if="btnEditVisible && privilege.button_jobSopTab_canUpdateJobSop" no="canUpdateJobSop" :disabled="isEdit || isFromFinance || !canEditTab || controlledLocked" type="primary" @click="btnEdit_clickHandler">{{ $t('SeaExport.EditionStatus') }}
            </el-button>
            <el-button v-if="btnSaveVisible" no="Save" :disabled="isEdit || isFromFinance" type="primary" @click="btnSave_clickHandler">{{ $t('SeaExport.Save') }}</el-button>
            <el-button v-if="btnCancelVisible" no="Cancel" :disabled="isEdit || isFromFinance" type="primary" @click="btnCancel_clickHandler">{{ $t('SeaExport.Cancel') }}</el-button>
            <el-button v-if="privilege.button_jobSopTab_canUpdateJobSopFrom3rd" no="canUpdateJobSopFrom3rd" :disabled="isEdit || isFromFinance || !canEditTab || controlledLocked" type="primary" @click="updateExternalStateHandler">{{ $t('SeaExport.UpdateExternalState') }}</el-button>
            <el-button v-if="!sopTemplateConfig || !sopTemplateConfig.forbidManualChangeTemplate" no="showChangeSopTemplateDialog" type="primary" :disabled="isEdit || !canEditTab || controlledLocked" @click="showChangeSopTemplateDialog">{{ $t('CargoMsg.Cargo_ReplaceTheSOPTemplate') }}</el-button>
            <el-button no="refreshHandler" type="primary" :disabled="isEdit || !canEditTab || controlledLocked" @click="refreshHandler">{{ $t('SeaExport.Refresh') }}</el-button>
            <i class="el-icon-question" style="color:#1F75D5; margin-left: 10px; font-size: 16px" @click="showWarningRuleTip=true" />
            <span v-show="showWarningRuleTip" style="color:#1F75D5;">{{ $t('CargoMsg.Cargo_WarningRuleTips') }}</span>
            <i v-show="showWarningRuleTip" class="el-icon-close" style="color:#1F75D5; font-size: 16px" @click="showWarningRuleTip=false" />
            <span style="float: right; margin-right: 10px;color:royalblue">{{ $t('CargoMsg.Cargo_ApplyTheSopTemplateAs') + (templateName || '') }}</span>
          </div>
        </div>
      </div>
      <div class="section">
        <el-form :inline="true" label-width="110px" label-position="left">
          <div v-for="data in dataSource" :key="data.tracking.uuid">
            <el-form-item v-if="data.visible && (data.tracking.isActive || isEditing)" class="label-none custom">
              <el-checkbox
                v-model="data.tracking.isActive"
                no="isActive"
                :disabled="!isEditing"
                :title="$t('SeaExport.IsDisplay') "
              />
            </el-form-item>
            <el-form-item v-if="data.visible && (data.tracking.isActive || isEditing)" class="custom">
              <span slot="label">
                <div>
                  <span>{{ StrUtils.isEmpty(data.trackingInfo.uuid) ? ($store.getters.language==='zh'?data.tracking.codeCname:data.tracking.codeEname) :($store.getters.language==='zh'?data.trackingInfo.codeCname:data.trackingInfo.codeEname) }}</span>
                  <div style="float: right;">
                    <i v-show="data.hasWarnInfo" class="el-icon-warning-outline" style="color: #F56C6C; margin-left: 10px" /><span v-show="data.hasWarnInfo" style="color: #F56C6C;">{{ $t('Sop.Warning') }}</span>
                  </div>
                </div>
              </span>
              <el-select
                no="subCode"
                :value="data.trackingInfo.subCode===''? $t('SeaExport.Uncertain'):data.trackingInfo.subCode"
                style="width:150px"
                :disabled="!isEditing || !data.tracking.isActive"
                @input="val=>{data.trackingInfo.subCode=val}"
                @change="p=>{stateChangeHandler(data)}"
              >
                <el-option
                  v-for="(item,index) in data.tracking.trackingDetail"
                  :key="index"
                  :label="$store.getters.language==='zh'?item.codeCname:item.codeEname"
                  :value="item.code"
                />
              </el-select>
              <!--
              <el-date-picker
                v-model="data.trackingInfo.modifyDate"
                :disabled="!isEditing || !data.tracking.changeAble"
                style="width:150px"
                type="date"
                value-format="yyyy-MM-dd"
                @change="dtfModifyChangeHandler(data)"
              />
              <el-input-number v-model="data.trackingInfo.modifyDateHour" :min="0" :max="23" style="width:50px" :controls="false" :disabled="!isEditing || !data.tracking.changeAble" />
              <span>:</span>
              <el-input-number v-model="data.trackingInfo.modifyDateMins" :min="0" :max="59" style="width:50px" :controls="false" :disabled="!isEditing || !data.tracking.changeAble" />
  -->

              <cargo-date-time-field-input
                v-model="data.trackingInfo.modifyDate"
                :disabled="!isEditing || !data.tracking.isActive"
              />
              <el-input v-model="data.trackingInfo.modifyByChineseName" no="modifyByChineseName" :controls="false" style="width:150px;margin-left:10px" readonly :disabled="!isEditing || !data.tracking.isActive" />
              <el-input
                v-model="data.trackingInfo.remark"
                no="remark"
                style="width:200px;margin-left:10px;margin-right:10px"
                :disabled="!isEditing || !data.tracking.isActive"
                @change="txtRemarkChangeHandler(data)"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.Remarks'),data.trackingInfo.remark,val=>{data.trackingInfo.remark=val})"
              />
              <template v-if="hasSendEmailPermission">
                <el-button v-if="data.tracking.isActive" no="SendEMail" type="primary" :disabled="isFromFinance || !cooperateEdit || controlledLocked" @click="sendEmailEventHandler(data)">{{ $t('SeaExport.SendEMail') }}</el-button>
                <span v-else style="margin-right: 10px;">{{ $t('CargoMsg.Cargo_TheNodeIsShutDown') }}</span>
              </template>
              <el-button v-show="!!job.masterFlag" no="SyncToSmallTicket" type="primary" :disabled="isFromFinance || !cooperateEdit || controlledLocked" @click="syncToSmallTicket(data)">{{ $t('SeaExport.SyncToSmallTicket') }}</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="section">
        <span>{{ $t('SeaExport.SopStateNote') }}</span>
      </div>

      <!-- 高级文本弹框 -->
      <el-dialog
        v-el-drag-dialog
        :visible.sync="advanceTextDialog.visible"
        :title="advanceTextDialog.title"
        width="600px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-input v-model="advanceTextDialog.value" type="textarea" rows="10" />
        <span slot="footer">
          <el-button no="confirm" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
          <el-button
            no="close"
            @click="advanceTextDialog.visible=false"
          >{{ $t('common.btn.close') }}</el-button>
        </span>
      </el-dialog>

      <!-- 发送邮件弹窗 -->
      <send-email-dialog v-if="sendEmailDialog.visible" :visible.sync="sendEmailDialog.visible" :context="context" :job="job" source="tabSopState" :send-email-data="sendEmailDialog" :send-call-back="sendCallBackEvent" :show-content="sendEmailDialog.showContent" />

    </div>
    <div v-if="isCrossTenantSeToSi" style="margin-left:10px;min-width:560px;float: right; height: 100%">
      <div class="section">
        <div style="margin: 5px;">
          <span style="font-size: 20px;">{{ $t('queryJob.AssociateBusinessSOPNode') }}</span>
          <span v-if="relatedJobNo" style="float: right;margin-right: 10px;">{{ $t('SeaExport.BusinessNo') }}：{{ relatedJobNo }}</span>
        </div>
        <el-form :inline="true" label-width="100px" label-position="left">
          <div v-for="data in targetDataSource" :key="data.tracking.uuid">
            <el-form-item v-if="data.visible" class="label-none custom">
              <el-checkbox
                v-model="data.tracking.isActive"
                no="isActive2"
                disabled
                :title="$t('SeaExport.IsDisplay') "
              />
            </el-form-item>
            <el-form-item v-if="data.visible" :label="StrUtils.isEmpty(data.trackingInfo.uuid) ? ($store.getters.language==='zh'?data.tracking.codeCname:data.tracking.codeEname) :($store.getters.language==='zh'?data.trackingInfo.codeCname:data.trackingInfo.codeEname)" class="custom">
              <el-select
                no="subCode2"
                :value="data.trackingInfo.subCode===''? $t('SeaExport.Uncertain'):data.trackingInfo.subCode"
                style="width:150px"
                disabled
                @input="val=>{data.trackingInfo.subCode=val}"
                @change="p=>{stateChangeHandler(data)}"
              >
                <el-option
                  v-for="(item,index) in data.tracking.trackingDetail"
                  :key="index"
                  :label="$store.getters.language==='zh'?item.codeCname:item.codeEname"
                  :value="item.code"
                />
              </el-select>
              <cargo-date-time-field-input
                v-model="data.trackingInfo.modifyDate"
                disabled
              />
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>

    <!-- 切换sop模板 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="changeSopTemplateVisible"
      :title="$t('CargoMsg.Cargo_SelectTheSopTemplateToApplyToTheBusiness')"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-ag-grid
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :show-side-bar="false"
        :row-data="rowData"
        style="width:100%;height:350px;"
      />
      <span slot="footer">
        <el-button no="confirm" type="primary" @click="changeJobSopTemplate">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="close"
          @click="changeSopTemplateVisible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script>
import { Job } from '@/class/model/booking/Job'
import { cacheName, cache } from '@/utils/cacheManager'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getObjectByCache } from '@/utils/basicDataCache'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { resolveSpecificField2Value } from '@/utils/basicDataCache'
import sendEmailDialog from '@/components/Cargo/Job/sendEmailDialog'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as TrackingConstants from '@/class/cargo/model/parameters/TrackingConstants'
import {
  getListByTemplateKey,
  saveTrackingNode,
  deleteTrackingNode,
  saveTrackingInfo,
  updateExternalTracking,
  getTemplateByUuid,
  rptWebService,
  getEmailContent,
  syncTrackingInfoToSlaveJob,
  getPendingListByJobUuid,
  changeJobSopTemplate
} from '@/api/trackingService'
import { TrackingInfo } from '@/class/model/booking/TrackingInfo'
import CargoDateTimeFieldInput from '@/components/Cargo/Common/cargoDateTimeFieldInput'
import StrUtils from '@/utils/StrUtils'
import { fileHistorySendEmailService } from '@/api/sendEmailService'
import { loadCrossTenantRelatedJob, loadJobRelated } from '@/api/booking/job'
import { getLoading } from '@/utils/utilBaseElement'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { queryTenantAllSopTemplate } from '@/api/sysManage/baseConfig/businessManage'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'TabSopState',
  components: { CargoDateTimeFieldInput, sendEmailDialog },
  props: {
    context: {
      type: Object,
      required: true
    },
    showButton: {
      type: Boolean,
      default: true
    },
    isFromFinance: { // 来源于财务模块
      type: Boolean,
      default: false
    },
    action: {
      type: String,
      required: true
    },
    viewSource: { // 页面请求发起方
      type: String,
      required: false
    },
    isCrossTenantSeToSi: { // 是否跨租户海出转海进
      type: Boolean,
      default: false
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    },
    controlledLocked: {
      type: Boolean,
      default: false
    },
    sopTemplateConfig: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      user: {},
      StrUtils,
      templateName: '', // sop模板名称
      showWarningRuleTip: false, // 是否显示预警提醒tip
      tempContent: '', // 临时存储邮件内容
      sendEmailDialog: {
        visible: false,
        emailTitle: '',
        emailContent: '',
        detailCode: '',
        showContent: false
      },
      isEditing: false,
      editState: false,
      btnEditVisible: true,
      btnSaveVisible: false,
      btnCancelVisible: false,
      isVisible: false,
      isZHLanguage: true,
      job: [],
      trackings: [], // 根据业务类型获取业务跟踪状态配置
      trackingInfo: [],
      warningData: [], // 预警的节点状态列表
      trackNodes: [],
      dataSource: [], // 数据结构 platformTracking，platformTracking.trackingDetail,trackingInfo
      targetDataSource: [], // 数据结构 platformTracking，platformTracking.trackingDetail,trackingInfo
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null
      },
      privilege: {
        button_jobSopTab_canUpdateJobSop: this.$checkPermission(['button_jobSopTab_canUpdateJobSop']),
        button_jobSopTab_canUpdateJobSopFrom3rd: this.$checkPermission(['button_jobSopTab_canUpdateJobSopFrom3rd'])
      },
      postTrackingInfos: [], // 保存对象
      postTrackingNodes: [], // 保存节点开启关闭对象
      trackingDetails: [],
      loading: null,
      changeSopTemplateVisible: false, // sop模板调整控制
      gridParams: {},
      gridApi: null,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        // 选中
        onRowClicked: (event) => {
          this.selectSopTemplate = event.data
        },
        context: {
          componentParent: this
        }
      },
      rowData: [],
      isZh: this.$store.getters.language === 'zh',
      selectSopTemplate: null, // 选中的模板
      sopTemplates: null // sop模板
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    canEditTab() {
      return (this.viewSource === 'salesDetail' && this.$checkPermission(['role_SalesQueryModule_editBusinessStatusTab'])) || this.viewSource !== 'salesDetail'
    },
    changeSopTitle() {
      let lobName = ''
      for (const lob of Array.from(SystemConstants.LOBS)) {
        if (lob.code === this.job.lob) {
          lobName = this.isZh ? lob.chineseName : lob.englishName
        }
      }
      return lobName + this.$t('CargoMsg.Cargo_SopTemplate')
    },
    columnDefs() {
      return [
        { headerName: this.changeSopTitle, field: 'templateName', colId: 'templateName', flex: 1
        }
      ]
    },
    relatedJobNo() {
      return this.job.relatedJob || this.job.trustFromJob
    },
    hasSendEmailPermission() {
      if (this.$store.getters.isAdmin) {
        return true
      }
      // 若存在权限则隐藏
      return !this.$checkPermission(['button_jobSop_prohibitsEmailSending'])
    }
  },
  watch: {
    showWarningRuleTip(val) {
      if (!val) {
        LocalStorageUtils.setConfiguration('showWarningRuleTip', 1)
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (!this.sopTemplates) {
        queryTenantAllSopTemplate().then(res => {
          this.sopTemplates = res.data
        })
      }
    },
    async onShow(row, isRefresh) {
      this.showWarningRuleTip = LocalStorageUtils.getConfiguration('showWarningRuleTip') !== 1
      // 获取 基础数据 业务配置信息 ，job 上的业务配置&状态跟踪
      if (isRefresh) {
        // 重置按钮状态
        this.btnEditVisible = true
        this.btnSaveVisible = false
        this.btnCancelVisible = false

        await cache.load(cacheName.USER, cacheName.CONFIG)
        this.user = cache.user
        this.isZHLanguage = this.$store.getters.language === 'zh'
        this.job = new Job(row)

        await this.changeJob()

        this.isEditing = this.isEditing && this.readonly

        this.editState = false
      } else {
        // CARGO-21591 ID：5973 玉漭 SOP节点触发后还需手动点击更新时间很不智能
        await this.changeJob()
      }
    },

    async changeJob() {
      if (!this.job.uuid) {
        this.trackings = []
        this.targetDataSource = []
        this.trackingInfo = []
        this.trackNodes = []
        return
      }
      this.templateName = ''
      this.trackings = []
      await getListByTemplateKey({ sopTemplateKey: this.job.trackingTemplateUuid }).then(res => {
        if (res.data) {
          this.templateName = res.data.templateName
          const trackings = res.data.trackingList
          for (const item of trackings) {
            item.isActive = false
            item.lbName = item.codeCname
          }
          this.trackings = trackings
        }
      })

      this.trackingInfo = []
      if (this.job.uuid) {
        const res = await loadJobRelated({ jobUuid: this.job.uuid, trackingInfo: true, trackingNode: true })
        for (const item of res.data.trackingInfo) {
          const trackingInfo = new TrackingInfo(item)
          trackingInfo.changeAble = true
          this.trackingInfo.push(trackingInfo)
        }
        this.trackNodes = res.data.trackingNode
        const warningRes = await getPendingListByJobUuid({ jobUuid: this.job.uuid })
        const warningData = {}
        if (warningRes.data && warningRes.data.length > 0) {
          for (const warning of warningRes.data) {
            warningData[warning] = true
          }
        }
        this.warningData = warningData
      }

      this.margeData()
      if (this.isCrossTenantSeToSi) {
        await this.loadRelatedJobSop()
      }
    },
    async loadRelatedJobSop() {
      const trackingInfos = []
      const res = await loadCrossTenantRelatedJob({ jobUuid: this.job.uuid, trackingInfo: true, trackingNode: true })
      for (const item of res.data.trackingInfo) {
        const trackingInfo = new TrackingInfo(item)
        trackingInfo.changeAble = true
        trackingInfos.push(trackingInfo)
      }
      const trackNodes = res.data.trackingNode
      this.targetDataSource = []
      const dataSourceList = []
      for (const track of res.data.trackings) {
        const dataSourceItem = {}
        // 比较job 上的trackingNode
        track.isActive = true
        this.changeTrackActive(trackNodes, track)
        dataSourceItem.tracking = track
        let existTrackingInfo = false
        for (const ti of trackingInfos) {
          if (ti.code === track.code) {
            dataSourceItem.trackingInfo = ti
            existTrackingInfo = true
            break
          }
        }
        // job 上无跟踪信息 赋值 状态名称标签& modify
        dataSourceList.push(dataSourceItem)

        // 避免job 上无 TrackingInfo（job 生成后调整了 业务跟踪状态配置）
        if (!existTrackingInfo) {
          dataSourceItem.trackingInfo = new TrackingInfo(new TrackingInfo().fillDefaultValue().getData())
          // 默认 状态未第一个
          if (track.trackingDetail && track.trackingDetail.length > 0) { dataSourceItem.trackingInfo.subCode = track.trackingDetail[0].code }
        }
        this.childCommitProperties(dataSourceItem)
      }
      this.targetDataSource = dataSourceList
    },
    margeData() {
      this.dataSource = []
      const dataSourceList = []
      for (const track of this.trackings) {
        const dataSourceItem = {}
        // 比较job 上的trackingNode
        track.isActive = true
        this.changeTrackActive(this.trackNodes, track)
        dataSourceItem.hasWarnInfo = this.changeWarningActive(track)
        dataSourceItem.tracking = track
        dataSourceItem.job = this.job
        let existTrackingInfo = false
        for (const ti of this.trackingInfo) {
          if (ti.code === track.code) {
            dataSourceItem.trackingInfo = ti
            existTrackingInfo = true
            break
          }
        }
        // job 上无跟踪信息 赋值 状态名称标签& modify
        dataSourceList.push(dataSourceItem)

        // 避免job 上无 TrackingInfo（job 生成后调整了 业务跟踪状态配置）
        if (!existTrackingInfo) {
          dataSourceItem.trackingInfo = new TrackingInfo(new TrackingInfo().fillDefaultValue().getData())
          // 默认 状态未第一个
          if (track.trackingDetail && track.trackingDetail.length > 0) { dataSourceItem.trackingInfo.subCode = track.trackingDetail[0].code }
        }

        this.childCommitProperties(dataSourceItem)
      }
      this.dataSource = dataSourceList
      this.btnStateVisible()
    },

    // TrackingDropDownListRender 中的
    childCommitProperties(dataSourceItem) {
      const tracking = dataSourceItem.tracking
      const trackingDetail = tracking.trackingDetail
      const trackingInfo = dataSourceItem.trackingInfo

      dataSourceItem.tracking.lbName = StrUtils.isEmpty(trackingInfo.uuid) ? tracking.codeCname : trackingInfo.codeCname

      if (!this.isZHLanguage) { StrUtils.isEmpty(trackingInfo.uuid) ? tracking.codeEname : trackingInfo.codeEname }

      if (trackingInfo.roleType > 1 && trackingInfo.modifyBy > 0) {
        const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(trackingInfo.modifyBy))
        if (company !== null) {
          dataSourceItem.trackingInfo.modifyByChineseName = company.shortName
        }
      } else {
        if (trackingInfo.roleType === 1 && trackingInfo.modifyBy > 0) {
          dataSourceItem.trackingInfo.modifyByChineseName = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', trackingInfo.modifyBy, 'chineseName')
          if (!this.isZHLanguage) {
            dataSourceItem.trackingInfo.modifyByChineseName = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', trackingInfo.modifyBy, 'englishName')
          }
        }
      }

      dataSourceItem.visible = !(tracking.nodeType === 6 || tracking.nodeType === 9)

      /* if (tracking.code === 'EXP Clearance') {
        console.log('========dataSourceItem', dataSourceItem)
      }*/

      // 判断 节点是否 选择了 状态，如果无 则清除相关时间及备注
      const selectTrackingDetail = trackingDetail ? trackingDetail.find(p => p.code === trackingInfo.subCode) : null
      if (!selectTrackingDetail || selectTrackingDetail.stateType === 1) {
        // trackingInfo.remark = ''
        trackingInfo.modifyDate = null
        trackingInfo.modifyDateHour = undefined
        trackingInfo.modifyDateMins = undefined
        // 此部分不影响 isDirty
        trackingInfo.isDirty = false
      }

      // 若是业务状态为空，则将节点的配置赋值给业务状态
      if (!trackingInfo.remark && tracking.remark) {
        trackingInfo.remark = tracking.remark
      }
    },
    changeTrackActive(trackNodes, t) {
      for (const tn of trackNodes) {
        if (tn.trackingUuid === t.uuid) {
          t.isActive = false
        }
      }
    },
    trackingExtis(trackNodes, key) {
      for (const tn of this.trackNodes) {
        if (tn.trackingUuid === key) {
          return false
        }
      }
      return true
    },
    activeTrackEventHandler(isActive, trackingUuid) {
      if (!isActive) {
        const trackingNode = {}
        trackingNode.jobUuid = this.job.uuid
        trackingNode.trackingUuid = trackingUuid
        saveTrackingNode(trackingNode).then(() => { this.trackingNodeHandler() })
      } else {
        deleteTrackingNode(this.job.uuid, trackingUuid).then(() => { this.trackingNodeHandler() })
      }
    },
    trackingNodeHandler() {
      this.getTrackFillModel(false)
      this.trackNodeHandler()
    },
    trackNodeHandler() {
      this.changeJob()
    },

    getTrackFillModel(isAddDetails = true) {
      this.childFillModel(isAddDetails)
    },
    // 保存
    btnSave_clickHandler() {
      if (this.job) {
        this.fillModel()
        saveTrackingInfo(this.postTrackingNodes).then(async res => {
          this.saveJobHandler()
          if (this.job.lob === 'SE') {
            this.$emit('refresh')
          }
        })
      }
    },

    fillModel() {
      this.trackingDetails = []
      this.postTrackingInfos = []
      this.getTrackFillModel()

      const addNodeKeys = []
      const delNodeKeys = []
      for (const data of this.dataSource) {
        const tkInfo = data.trackingInfo
        const tracking = data.tracking
        if (tracking.isActive) {
          delNodeKeys.push(tracking.uuid)
        } else {
          addNodeKeys.push(tracking.uuid)
        }
        if (tkInfo.isDirty && tkInfo.jobUuid) {
          tkInfo.roleType = 1
          this.postTrackingInfos.push(tkInfo._data)
        }
      }
      this.postTrackingNodes = {
        addNodeKeys,
        delNodeKeys,
        jobUuid: this.job.uuid,
        trackingInfos: this.postTrackingInfos
      }
    },
    // 保存业务状态
    saveJobHandler() {
      if (this.trackingDetails) {
        // Config.configMap["SynPortalShipmentOrder"]) == 1 分支 逻辑不需要开发了，此功能 租户未使用了
        this.$message.success(this.$t(`Message.OrderInformationWasSuccessfullyUpdated`))
        this.trackingDetails = null
        this.msgHander()
        // todo 用于 列表动态列的显示 由列表实现
        /* if (this.job !== null) {
          SopStateUtil.initJobSopStateAttr(job)
          job.sopState = SopStateUtil.getSopState(job, false)
        }
       dispatchEvent(new Event('jobStateChanged'));*/
      }
    },
    //  trackingDropdownlistRender 上的 fillModel
    childFillModel(isAddDetails = true) {
      for (const data of this.dataSource) {
        // 选中的状态List项
        if (!data.tracking.trackingDetail || data.tracking.trackingDetail.length === 0) {
          continue
        }
        const trackingDetail = data.tracking.trackingDetail.find(p => p.code === data.trackingInfo.subCode)
        if (data.tracking.isActive && trackingDetail) {
          if (trackingDetail.stateType > 1) {
            if (data.trackingInfo.isDirty) {
              if (data.trackingInfo.modifyDate === '') {
                data.trackingInfo.modifyDate = new Date()
              }
              data.trackingInfo.modifyBy = this.user.userId
            }
          } else {
            data.trackingInfo.modifyBy = 0
            data.trackingInfo.modifyByChineseName = ''
            data.trackingInfo.modifyDate = null
          }
          // 此部分放置此处 避免 新增的节点 modifyDate 被更新
          if (StrUtils.isEmpty(data.trackingInfo.jobUuid)) {
            data.trackingInfo.jobUuid = this.job.uuid
            data.trackingInfo.isDirty = true
          }

          // 重新将 状态配置信息赋值
          data.trackingInfo.code = data.tracking.code
          data.trackingInfo.codeCname = data.tracking.codeCname
          data.trackingInfo.codeEname = data.tracking.codeEname
          data.trackingInfo.subCodeCname = trackingDetail.codeCname
          data.trackingInfo.subCodeEname = trackingDetail.codeEname

          data.trackingInfo.trackingDetailUuid = trackingDetail.uuid // 触发sop新增费用使用
          trackingDetail.finishedDateTime = data.trackingInfo.modifyDate
          // todo trackingDetail.isTrigger = ddlState.selectedIndex == 0 ? true : false
          if (isAddDetails) {
            this.trackingDetails.push(trackingDetail)
          }
        }
      }
    },
    msgHander() {
      this.isEditing = false
      this.editState = false
      this.refreshHandler()
      this.btnStateVisible()
    },
    btnEdit_clickHandler() {
      this.isEditing = true
      this.editState = true
      this.btnStateVisible()
    },
    btnCancel_clickHandler() {
      this.msgHander()
    },
    refreshHandler() {
      this.changeJob()
    },
    async updateExternalStateHandler() {
      const trackingKeys = []
      for (const tracking of this.trackings) {
        for (const trackingDetail of tracking.trackingDetail) {
          if (this.isExternal(trackingDetail.event) && !this.isTrackinged(tracking.code, trackingDetail)) {
            trackingKeys.push(tracking.uuid)
            break
          }
        }
      }
      if (trackingKeys.length === 0) {
        this.$message.warning(this.$t(`Message.NoExternalUpdateInformation`))
        return
      }
      const parmsRequest = {
        jobUuid: this.job.uuid,
        trackingKeys: trackingKeys
      }
      await updateExternalTracking(parmsRequest).then(res => {
        if (res.data.count === 0) {
          this.$message.warning(this.$t(`Message.NoExternalUpdateInformation`))
        } else {
          this.trackingUpdateResultHandler()
        }
      })
    },
    trackingUpdateResultHandler() {
      // 重新加载
      this.changeJob()
    },
    // 是否是外部
    isExternal(event) {
      const service = CommonState.getStateByCode(TrackingConstants.EX_TRIGGERS, event)
      return service != null
    },
    // 是否已经跟踪过
    isTrackinged(trackingCode, trackingDetail) {
      let trackinged = false
      for (const trackingInfo of this.trackingInfo) {
        if (trackingInfo.code === trackingCode && trackingInfo.subCode === trackingDetail.code) {
          trackinged = true
          break
        }
      }
      return trackinged
    },
    stateCb_changeHandler() {
      this.changeJob()
    },
    /* 节点状态修改 changeHandler */
    stateChangeHandler(data) {
      // todo 状态下拉绑定显示值 中英文 显示 未区分判断
      // 选中的 trackingDetail 对象
      const selectState = data.trackingInfo.subCode
      if (!data.tracking.trackingDetail || data.tracking.trackingDetail.length === 0) {
        return
      }
      const trackingDetail = data.tracking.trackingDetail.find(p => p.code === selectState)
      if (trackingDetail && trackingDetail.stateType > 1) {
        data.trackingInfo.modifyDate = this.nowDateToString()
        data.trackingInfo.modifyByChineseName = this.$getLangColumn(this.user)
        data.trackingInfo.modifyBy = this.user.userId
        if (!data.trackingInfo.remark) { // 业务状态配置未设置时，才改成节点状态的备注
          data.trackingInfo.remark = trackingDetail.remark
        }
        data.trackingInfo.trackingDetailUuid = trackingDetail.uuid // 触发sop新增费用使用
        data.trackingInfo.isDirty = true
      }
    },
    // 当前日期时间 转string
    nowDateToString() {
      const date = new Date()
      let fmt = 'yyyy-MM-dd hh:mm:ss'
      const o = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'h+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'S': date.getMilliseconds() // 毫秒
      }
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
        }
      }
      return fmt
    },
    txtRemarkChangeHandler(data) {
      data.trackingInfo.isDirty = true
    },
    dtfModifyChangeHandler(data) {
      const nowDate = new Date()
      data.trackingInfo.modifyDateHour = nowDate.getHours()
      data.trackingInfo.modifyDateMins = nowDate.getMinutes()
      data.trackingInfo.isDirty = true
    },
    /* 按钮状态控制*/
    btnStateVisible() {
      this.btnEditVisible = !this.editState
      this.btnSaveVisible = this.editState
      this.btnCancelVisible = this.editState

      this.trackingDropDownListRendererChanged()
    },
    /**
     * 是否编辑
     */
    trackingDropDownListRendererChanged() {
      for (let i = 0; i < this.dataSource.length; i++) {
        const item = this.dataSource[i].tracking
        if (item) {
          item.changeAble = item.isActive === null ? true : item.isActive
        }
      }
    },
    async sendEmailEventHandler(data) {
      if (data.tracking.trackingDetail === null || data.tracking.trackingDetail.length === 0) {
        this.$message.warning(this.$t(`Message.NodeStatusIsNotPreserved`))
        return
      }
      // 选中的状态List项
      const currentTrackingDetail = data.tracking.trackingDetail.find(p => p.code === data.trackingInfo.subCode)
      if (currentTrackingDetail && currentTrackingDetail.templateUuid === '') {
        this.$message.warning(this.$t(`Message.TheNodeAffinityForTheMailTemplateIsNotMaintained`))
        return
      }
      // 生成邮件正文
      if (currentTrackingDetail.code === '') {
        this.$message.warning(this.$t('SeaExport.MaintainNodeDetailCode'))
        return
      }
      this.sendEmailDialog.detailCode = currentTrackingDetail.code
      let isExcute = false
      // 获取模板
      await getTemplateByUuid(currentTrackingDetail.templateUuid).then(async res => {
        const templateObj = res.data
        this.sendEmailDialog.emailTitle = templateObj['name']
        isExcute = await this.getTemplateUuidBySchemaTypeHandler(templateObj) // 获取模板内容
      })
      //   Put Cabin  和 Apply Shipper 两种code 单独取
      if (this.tempContent === '') {
        await getEmailContent(this.job.uuid, currentTrackingDetail.code).then(async res => {
          this.tempContent = res.data
        })
      }
      if (this.tempContent) this.sendEmailDialog.emailContent = this.tempContent
      this.sendEmailDialog.visible = isExcute
    },
    async getTemplateUuidBySchemaTypeHandler(templateObj) {
      if (templateObj === null) {
        this.$message.warning(this.$t(`Message.DoNotLocateAnAssociatedPrintTemplateType`))
        return false
      }
      // 获取邮件内容
      const rptFile = templateObj['templateFile']
      const schemaClass = templateObj['schemaType']
      await rptWebService(rptFile, schemaClass, this.job.uuid).then(res => {
        this.tempContent = res.data
      })
      if (this.tempContent.indexOf('[ERROR]') > -1) {
        this.$message.warning(this.tempContent)
        return false
      }
      return true
    },
    sendCallBackEvent(to, cc, title, content) {
      const item = {}
      item.to = to
      item.cc = cc
      item.content = this.tempContent || content
      item.title = title
      item.emailTemplateName = 'sopMail'
      fileHistorySendEmailService(item).then(res => {
        if (res.ok) {
          this.sendEmailDialog.visible = false
          this.$message({
            type: 'success',
            message: this.$t(`Message.TheEmailWasSentPleaseNoteTheQuery`)
          })
        } else {
          this.$message({
            type: 'info',
            message: this.$t('SeaExport.MailSendingFailed')
          })
        }
      }).catch(() => {
        // this.$message.error(err)
      }).finally(() => {
        this.tempContent = ''
      })
    },
    showAdvanceTextDialog(title, value, successCallback) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.visible = true
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    async syncToSmallTicket(data) { // 同步至小票
      if (!await SecurityUtil.canEdit(this.job, false)) {
        this.$message.info(this.$t('Message.NoPermissionToEditTheJob'))
        return
      }
      if (this.job && data.trackingInfo) {
        this.loading = getLoading()
        syncTrackingInfoToSlaveJob({ jobUuid: this.job.uuid, trackingInfoUuid: data.trackingInfo.uuid }).then(res => {
          if (res.data) {
            let lableName = ''
            const isZh = this.$store.getters.language === 'zh'
            if (data.trackingInfo.uuid) {
              if (isZh) {
                lableName = data.trackingInfo.codeCname
              } else {
                lableName = data.trackingInfo.codeEname
              }
            } else {
              if (isZh) {
                lableName = data.tracking.codeCname
              } else {
                lableName = data.tracking.codeEname
              }
            }
            this.$message.success(this.$t('Message.SyncToSmallTicketSuccessTips', [lableName]))
          } else {
            this.$message.error(this.$t('CargoMsg.Cargo_UpdateFailed'))
          }
        }).finally(() => {
          this.loading.close()
        })
      }
    },
    changeWarningActive(tracking) {
      if (!tracking.trackingDetail || tracking.trackingDetail.length === 0) {
        return false
      }
      const currentTrackingDetail = tracking.trackingDetail.find(p => this.warningData.hasOwnProperty(p.uuid))
      return currentTrackingDetail
    },
    showChangeSopTemplateDialog() {
      this.changeSopTemplateVisible = true
      this.rowData = []
      if (this.sopTemplates && this.job.lob) {
        for (const item of this.sopTemplates) {
          if (item.lob === this.job.lob && item.sopStatus) {
            if (item.onlyApplyDepartmentAndHq && item.branch && item.department) {
              const branchIds = item.branch.split(',').map(item => Number(item))
              const departmentIds = item.department.split(',').map(item => Number(item))
              if (departmentIds.includes(this.job.opDepartment) || branchIds.includes(1)) {
                this.rowData.push(item)
              }
              continue
            }
            if (item.onlyApplyBranchAndHq && item.branch) {
              const branchIds = item.branch.split(',').map(item => Number(item))
              if (branchIds.includes(this.job.opOffice) || branchIds.includes(1)) {
                this.rowData.push(item)
              }
              continue
            }
            this.rowData.push(item)
          }
        }
      }
      // 默认选中当前模板
      this.$nextTick(() => {
        const api = this.gridOptions.api
        setTimeout(() => {
          const nodes = api.rowModel.rowsToDisplay
          const node = nodes.find(node => node.data.uuid === this.job.trackingTemplateUuid)
          if (node) {
            api.setFocusedCell(node.rowIndex, api.columnController.getAllDisplayedColumns()[0])
            this.selectSopTemplate = node.data
          } else {
            api.clearFocusedCell()
            this.selectSopTemplate = null
          }
        }, 200)
      })
    },
    async changeJobSopTemplate() {
      const selectSopTemplate = this.selectSopTemplate
      if (!selectSopTemplate || !selectSopTemplate.uuid) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectAnSOPTemplate'))
        return
      }
      // 于当前业务sop模板一致，不变更
      if (this.job.trackingTemplateUuid === selectSopTemplate.uuid) {
        this.changeSopTemplateVisible = false
        return
      }
      // 不一致时，询问是否需要保留
      await this.$confirm(this.$t('CargoMsg.Cargo_MakeSureToApplyTheSopTemplate', [selectSopTemplate.templateName]), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Apply'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        closeOnClickModal: false,
        showClose: false,
        closeOnPressEscape: false,
        type: 'info'
      }).then(() => {
        // 选是时会记录后续该业务都不更新，针对个人有效
        LocalStorageUtils.setConfiguration(this.job.jobNo + '-sopTemplateChange', true)
        this.changeSopTemplateVisible = false
        this.loading = getLoading()
        changeJobSopTemplate({ jobUuid: this.job.uuid, trackingTemplateKey: selectSopTemplate.uuid }).then(res => {
          if (res.data) {
            this.$message.success(this.$t('SeaExport.UpdateSuccess'))
            this.job.trackingTemplateUuid = selectSopTemplate.uuid
            this.$nextTick(() => {
              this.changeJob()
            })
          } else {
            this.$message.success(this.$t('CargoMsg.Cargo_UpdateFailed'))
          }
        })
      }).catch(() => {
        this.changeSopTemplateVisible = false
      }).finally(() => {
        this.loading.close()
      })
    }
  }
}
</script>

<style>
</style>
